import { Paper } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    height: '100%',
  },
  sidebar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.primary.main,
    paddingBottom: theme.spacing(5),
    width: theme.dimensions.sidebarWidth,
    [theme.breakpoints.down('lg')]: {
      width: theme.dimensions.sidebarWidthTablet,
    },
    [theme.breakpoints.down('sm')]: {
      width: '0px',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    position: "relative",
    overflow: "hidden",
    transition: "background 0.6s ease-in-out, background-image 0.6s ease-in-out",
    backgroundSize: '400% 400%',

    "&::before": {
      content: '""',
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background: `linear-gradient(45deg,
        ${theme.palette.primary.light} 0%,
        ${theme.palette.secondary.main} 50%,
        ${theme.palette.primary.dark} 100%)`,
      opacity: 0.1,
      animation: "rotate 15s infinite linear",
      zIndex: 0,
    },
    "@keyframes rotate": {
      "0%": { transform: "rotate(0deg)" },
      "100%": { transform: "rotate(360deg)" },
    },
    boxShadow: `
      0 16px 32px rgba(0, 0, 0, 0.2),
      0 0 0 1px rgba(255, 255, 255, 0.1) inset
    `,
    [theme.breakpoints.down('sm')]: {
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      borderRadius: 0,
      justifyContent: "center",
      paddingTop: theme.spacing(4),
    },
    animation: "$gradientShift 30s ease infinite",
    "@keyframes gradientShift": {
      "0%": { backgroundPosition: "0% 50%" },
      "50%": { backgroundPosition: "100% 50%" },
      "100%": { backgroundPosition: "0% 50%" },
    }
  },
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
    },
    position: 'relative',
    zIndex: 1,
  },
}));


const LoginLayout = ({ children }) => {
  const { classes } = useStyles();
  const theme = useTheme();

  const [backgroundAvailable, setBackgroundAvailable] = useState({
    light: null,
    dark: null,
  });

  useEffect(() => {
    const checkImage = (src) =>
      new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = src;
      });

    const verifyBackgrounds = async () => {
      const [lightOk, darkOk] = await Promise.all([
        checkImage('/imagens/light-background.webp'),
        checkImage('/imagens/dark-background.webp'),
      ]);
      setBackgroundAvailable({ light: lightOk, dark: darkOk });
    };

    verifyBackgrounds();
  }, []);

  const lightPattern = `linear-gradient(135deg, #e6f0ff 0%, #d0e1ff 25%, #ffffff 50%, #e6f0ff 100%),
    radial-gradient(circle at 10% 20%, rgba(255,255,255,0.1) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(255,255,255,0.1) 0%, transparent 20%)`;

  const darkPattern = `linear-gradient(135deg, #0a192f 0%, #0d1f3a 25%, #122b4a 50%, #0a192f 100%),
    radial-gradient(circle at 10% 20%, rgba(0,184,212,0.05) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(0,184,212,0.05) 0%, transparent 20%)`;

  const getBackgroundStyle = () => {
    const isDarkMode = theme.palette.mode === 'dark';

    if (
      (isDarkMode && backgroundAvailable.dark) ||
      (!isDarkMode && backgroundAvailable.light)
    ) {
      const backgroundImage = isDarkMode
        ? 'url(/imagens/dark-background.webp)'
        : 'url(/imagens/light-background.webp)';
      return {
        backgroundImage,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        zIndex: 0
      };
    } else {
      return {
        backgroundImage: isDarkMode ? darkPattern : lightPattern,
        backgroundSize: '400% 400%', // <-- Aqui
        animation: 'gradientShift 20s ease infinite',
        backgroundPosition: 'center',
        zIndex: 0
      };
    }
  };

  return (
    <main className={classes.root}>
      <Paper className={classes.paper} style={getBackgroundStyle()}>
        <form className={classes.form}>
          {children}
        </form>
      </Paper>
    </main>
  );
};

export default LoginLayout;